module.exports = __webpack_public_path__ + "fonts/3f91c0c.ttf";